export const initialState = {
  isFetching: {},
  filters: {},
  page: {},
  perPage: {},
  sortBy: {},
  isSortAscending: {},
  asof: {},
  isLocked: {},
  lastFetchedState: {}
}
